import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  displayForm: number;
  userEmail: string;
  reason: string;

  constructor() {}

  ngOnInit(): void {
    this.displayForm = 0;
    this.userEmail = '';
  }

  toggleView(displayForm: { id: number; email?: string; reason?: string }): void {
    this.displayForm = displayForm.id;
    this.userEmail = displayForm.email || '';
    this.reason = displayForm.reason || '';
  }
}
